<template>
  <el-dialog
    :visible="modalOpen"
    :append-to-body="true"
    width="650px"
    :before-close="handleModalCancel"
  >
    <div class="show-stream-node-modal">
      <div class="video-item-title">
        <span class="stream-node-name">{{gisMarker.name}}</span>
        <i @click="handleToggleVideo" class="toggle-video-btn el-icon-video-camera" :style="{color: player.active ? '#1DD3B8' : ''}"></i>
      </div>
      <div class="image-block video-item-content" ref="videoPlayerContainer" >
        <!--视频控件-->
        <video id="video-player1" ref="videoPlayer" class="video-player"  v-show="player.active" controls autplayerParamslay style="height: 300px"></video>
        <el-image v-if="!player.active" :src="gisMarker.pictureUrl" style="height: 300px">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <!--接入、资产、建设、使用、运维等信息内容-->
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="接入信息" name="0">
          <ul class="label-value-list">
            <li><span class="label-mini">名称</span><span class="value-mini">{{ gisMarker.name }}</span></li>
            <li><span class="label-mini">IP</span><span class="value-mini">{{ gisMarker.ip }}</span></li>
            <li><span class="label-mini">端口</span><span class="value-mini">{{ gisMarker.port }}</span></li>
            <li><span class="label-mini">用户名</span><span class="value-mini">{{ gisMarker.userName }}</span></li>
            <li><span class="label-mini">登录口令</span><span class="value-mini">{{ gisMarker.password }}</span></li>
            <li><span class="label-mini">接入设备</span><span class="value-mini">{{ getNameById(gisMarker.encoderId, $globalData.encoders)}}</span>
            </li>
            <li><span class="label-mini">接入通道号</span><span class="value-mini">{{ gisMarker.encoderVideoInputNum }}</span></li>
          </ul>
          <ul class="label-value-list">
            <li><span class="label-mini">流访问模式</span><span class="value-mini">{{ getNameById(gisMarker.streamOpenMode,$type.streamOpenModes) }}</span>
            </li>
            <li><span class="label-mini">所属区域</span><span class="value-mini">{{ getNameById(gisMarker.regionId, $globalData.regions) }}</span>
            </li>
            <li><span class="label-mini">接入状态</span><span class="value-mini">
              {{$type.getResourceAlarmStateText(gisMarker.resourceKind, gisMarker.alarmState, gisMarker.eventTypeSet, 1, gisMarker.encoderAlarmState, gisMarker.encoderEventTypeSet)}}
            </span>
            </li>
            <li><span class="label-mini">资源代码</span><span class="value-mini">{{ gisMarker.resourceCode }}</span></li>
            <li><span class="label-mini">密级程度</span><span
              class="value-mini">{{ getNameById(gisMarker.secrecy,$type.secrecys) }}</span></li>
            <li><span class="label-mini">注册方式</span><span class="value-mini">{{ getNameById(gisMarker.registerWay,$type.registerWays) }}</span>
            </li>
            <li><span class="label-mini">信令安全模式</span><span class="value-mini">{{ getNameById(gisMarker.safetyWay,$type.safetyWays) }}</span>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="设备信息" name="1">
          <ul class="label-value-list">
            <li><span class="label-mini">资产编号</span><span class="value-mini">{{ gisMarker.assetNum }}</span></li>
            <li><span class="label-mini">摄像机类型</span><span class="value-mini">{{ getNameById(gisMarker.resourceSubType, $type.streamObjectKinds) }}</span>
            </li>
            <li><span class="label-mini">厂商</span><span class="value-mini">{{ gisMarker.manufactor }}</span></li>
            <li><span class="label-mini">品牌</span><span class="value-mini">{{ gisMarker.brand }}</span></li>
            <li><span class="label-mini">型号</span><span class="value-mini">{{ gisMarker.model }}</span></li>
          </ul>
          <ul class="label-value-list">
            <li><span class="label-mini">规格</span><span class="value-mini">{{ gisMarker.spec }}</span></li>
            <li><span class="label-mini">过保日期</span><span class="value-mini">{{ strDateFromInt(gisMarker.expiryDate) }}</span></li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="建设信息" name="2">
          <ul class="label-value-list">
            <li><span class="label-mini">安装地点</span><span class="value-mini">{{ gisMarker.installationPlace }}</span></li>
            <li><span class="label-mini">安装日期</span><span class="value-mini">{{ strDateFromInt(gisMarker.installationDate) }}</span>
            </li>
            <li><span class="label-mini">设备归属</span><span class="value-mini">{{  getNameById(gisMarker.ownerDepartmentId, $globalData.departments) }}</span>
            </li>
            <li><span class="label-mini">建设单位联系人</span><span class="value-mini">{{ getNameById(gisMarker.ownerPersonId, $globalData.persons) }}</span>
            </li>
            <li><span class="label-mini">建设单位电话</span><span class="value-mini">{{ gisMarkerOwnerPersonPhone }}</span></li>
            <li><span class="label-mini">所属项目</span><span class="value-mini">{{ getNameById(gisMarker.projectId, $globalData.projects) }}</span>
            </li>
            <li><span class="label-mini">行政编码</span><span class="value-mini">{{ gisMarker.civilCode }}</span></li>
          </ul>
          <ul class="label-value-list">
            <li><span class="label-mini">经度</span><span class="value-mini">{{ gisMarker.longitude }}</span></li>
            <li><span class="label-mini">纬度</span><span class="value-mini">{{ gisMarker.latitude }}</span></li>
            <li><span class="label-mini">室内室外</span><span
              class="value-mini">{{ getNameById(gisMarker.roomType, $type.roomTypes) }}</span></li>
            <li><span class="label-mini">安装位置类型</span><span class="value-mini">{{ getNameById(gisMarker.positionType, $type.positionTypes) }}</span>
            </li>
            <li><span class="label-mini">监视方位</span><span class="value-mini">{{ gisMarker.expandInfo }}</span></li>
            <li><span class="label-mini">取流方式</span><span class="value-mini">{{ gisMarker.expandInfo }}</span></li>
            <li><span class="label-mini">是否有拾音器</span><span class="value-mini">{{ gisMarker.expandInfo }}</span></li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="维保信息" name="3">
          <ul class="label-value-list">
            <li><span class="label-mini">维保单位</span><span class="value-mini">{{ getNameById(gisMarker.maintenanceDepartmentId, $globalData.departments) }}</span>
            </li>
            <li><span class="label-mini">维保负责人</span><span class="value-mini">{{ getNameById(gisMarker.maintenancePersonId, $globalData.persons) }}</span>
            </li>
            <li><span class="label-mini">维保联系电话</span><span class="value-mini">{{ gisMarkerMaintenancePersonPhone }}</span></li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="应用信息" name="4">
          <ul class="label-value-list">
            <li><span class="label-mini">所属辖区</span><span class="value-mini">{{ gisMarker.block }}</span></li>
            <li><span class="label-mini">用途</span><span
              class="value-mini">{{ getNameById(gisMarker.useType, $type.useTypes) }}</span></li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import ShowStreamNodeModal from './ShowStreamNodeModal.js'
export default ShowStreamNodeModal
</script>

<style lang="scss">
@import "ShowStreamNodeModal";
</style>



// WEBPACK FOOTER //
// src/views/common/showStreamNodeModal/ShowStreamNodeModal.vue